import React, { useState, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useSpring, animated } from 'react-spring'
import './TheSidebar.css'
import { PATH } from '../../../data/router_path'

import { Icon } from '@iconify/react'
const ICON_STYLE_CONFIG = {
  base: 'text-[22px] text-gray-accent',
}
function DropdownItem(props) {
  const [isOpen, setIsOpen] = useState(false)
  const contentRef = useRef(null)
  const location = useLocation()

  const contentHeight = contentRef.current ? contentRef.current.scrollHeight : 0

  const animation = useSpring({
    height: isOpen ? contentHeight : 0,
    opacity: isOpen ? 1 : 0,
    overflow: 'hidden',
  })

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const isPathInactive = (path) => {
    if (path === PATH.BOOK.LIST) {
      return location.pathname === PATH.BOOK.UPLOAD_SINGLE || location.pathname.startsWith(PATH.BOOK.EDIT())
    }
    return false
  }

  return (
    <section>
      <div
        className="flex w-full cursor-pointer items-center justify-between py-4"
        onClick={handleToggle}
      >
        <span className="basic-1/6 ml-4">
          {isOpen ? props.dataSidebar.darkIcon : props.dataSidebar.lightIcon}
        </span>
        <div className="ml-3 mr-6 flex basis-5/6 items-center justify-between">
          <p className="basis-4/6 text-lg font-semibold">
            {props.dataSidebar.title}
          </p>
          <span className="mb-2 h-[22px] w-[22px]">
            {isOpen ? (
              <Icon
                icon="ph:caret-up-bold"
                className={ICON_STYLE_CONFIG.base}
              />
            ) : (
              <Icon
                icon="ph:caret-down-bold"
                className={ICON_STYLE_CONFIG.base}
              />
            )}
          </span>
        </div>
      </div>
      <animated.div style={animation}>
        <div ref={contentRef} className="dropDownMenu">
          {props.dataSidebar.dropChildren.map((item, index) => (
            <div
              key={index}
              className="ml-2 flex w-full cursor-pointer items-center justify-end"
            >
              <NavLink
                style={{ color: '#909090' }}
                to={item.path}
                className={({ isActive }) =>
                  isActive || isPathInactive(item.path)
                    ? 'onclicklist item-hover mr-6 flex w-10/12 items-center justify-between py-3 pl-4'
                    : 'item-hover mr-6 flex w-10/12 items-center justify-between py-3 pl-4'
                }
              >
                <p className="w-full text-lg font-semibold">{item.name}</p>
              </NavLink>
            </div>
          ))}
        </div>
      </animated.div>
    </section>
  )
}

export default DropdownItem
